import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { CallBackService } from "../../../../pages/callback/services/CallBack.service";
import { TutorialService } from "../../tutorial/services/tutorial.service";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { FormGroup } from "@angular/forms";
import { MatSidenav } from "@angular/material/sidenav";
import { firstValueFrom, Observable, Subscription, take } from "rxjs";
import { SignalUser } from "../../../../shared/models/SignalUser/SignalUser";
import { EncriptionService } from "../../../../shared/services/Encription.service";
import { PermissionsService } from "../../../../shared/services/ServiceCatalogEncapsulators/Permissions.service";
import { SignalUserService } from "../../../../shared/services/ServiceCatalogEncapsulators/Signal-User.service";
import { SessionService } from "../../../../shared/services/Session.service";
import { SignalRService } from "../../../../shared/services/Signal-R.service";
import { NavHeaderService } from "../service/nav-header.service";
import { AuthService } from "src/app/features/pages/authmanagement/services/Auth.service";
import { NotificationDTO } from "src/app/features/pages/notifications/models/NotificationDTO";
import { NotificationService } from "src/app/features/pages/notifications/services/Notification.service";
import { SwalNotificationService } from "../../../../shared/services/SwalNotification.service";
import { AlarmService } from "src/app/features/pages/alarms/services/Alarm.service";
import { ImageCacheService } from "../../../../shared/services/ImageCache.service";
import { MatDialog } from "@angular/material/dialog";
import { LayerService } from "src/app/features/map-features/sections/locations-section/services/Layers.service";
import { InfoBoxMapService } from "src/services/maps/features/InfoBox-Map.service";
import { CustomerConfigurationsDTO } from "../../../../shared/models/Customers/CustomerConfigurationsDTO";
import { environment } from "src/environments/environment";
import { LocalStorageService } from "../../../../shared/services/LocalStorage.service";
import { PermissionFilterPipe } from "../../../../shared/pipes/Permission-filter.pipe";
import { MapHelperService } from "src/services/map-helper.service";
import { MAP_COMPONENT_NAMES, MAP_MODULE_NAMES } from 'src/models/common/EnumMapas';
import { ControlPanelService } from "src/app/features/pages/main-dashboard/services/ControlPanel.service";

@Component({
  selector: "nav-header",
  templateUrl: "./nav-header.component.html",
  styleUrls: ["./nav-header.component.css"],
  animations: [
    trigger("mostrarNotificaciones", [
      state("visible", style({ opacity: 1, height: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
    trigger("expandCollapseOptions", [
      state("visible", style({ opacity: 1, width: "*" })),
      state("hidden", style({ opacity: 0, width: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
  ],
})
export class NavHeaderComponent implements OnInit {
  @ViewChild('snav') sidenav: MatSidenav;
  
  signalUser: SignalUser = new SignalUser();
  isExpanded = false;
  roles: string[];
  clienteDisplay: string = "Cargando...";
  selectedClient: CustomerConfigurationsDTO;
  public clientes: CustomerConfigurationsDTO[] = [];
  form: FormGroup;
  mobileQuery: MediaQueryList;
  userName: any;
  isBlocked: boolean = true;
  isLoading: boolean = false;
  isEnlargedSideBar: boolean = false;
  areOptionsExpanded: boolean = false;
  closeTimeout: any;
  views: any = [];
  filteredViews: any = [];
  notificationList: NotificationDTO[] = [];
  public $isLocationSelected: Observable<boolean> = new Observable<boolean>();
  public $isRoutesSelected: Observable<boolean> = new Observable<boolean>();
  public $isGeofencesSelected: Observable<boolean> = new Observable<boolean>();

  public $clientes: Observable<CustomerConfigurationsDTO[]> = new Observable<CustomerConfigurationsDTO[]>();
  public $clienteDisplay: Observable<string> = new Observable<string>();
  public $views: Observable<string[]> = new Observable<string[]>();

  $pushedClassSelected: Observable<string> = new Observable<string>();
  isLocationSelected: boolean;
  isRoutesSelected: boolean;
  isGeofencesSelected: boolean;
  pushedClassSelected: string;

  private _mobileQueryListener: () => void;
  fillerNav = Array.from({ length: 50 }, (_, i) => `Nav Item ${i + 1}`);
  isMapix: boolean;
  isExternalMap: boolean;
  
  subscription_SetClients: Subscription;
  subscription_GetAlarms: Subscription;
  subscription_isLocationSelected: Subscription;
  subscription_isRoutesSelected: Subscription;
  subscription_isGeofencesSelected: Subscription;
  subscription_pushedClassSelected: Subscription;
  subscription_clientes: Subscription;
  subscription_clienteDisplay: Subscription;
  subscription_views: Subscription;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private authService: AuthService,
    public sessionService: SessionService,
    private router: Router,
    private callbackService: CallBackService,
    public permissionService: PermissionsService,
    private routerService: Router,
    public navHeaderService: NavHeaderService,
    public notificationService: NotificationService,
    public notifyService: SwalNotificationService,
    private alarmService: AlarmService,
    private signalRService: SignalRService,
    private signalUserService: SignalUserService,
    private tutorialService: TutorialService,
    private encriptionService: EncriptionService,
    private imageCacheService: ImageCacheService,
    private eRef: ElementRef,
    private dialog: MatDialog,
    private layerCatalogService: LayerService,
    private infoBoxMapService: InfoBoxMapService,
    private maphelperService: MapHelperService,
    private controlPanelService: ControlPanelService,
    private localStorageService: LocalStorageService,
    private permissionFilterPipe: PermissionFilterPipe,
  ) {
    this.isLoading = false;
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userName = this.localStorageService.getUserName();
    setTimeout(() => {
      this.eventoDespuesDe12Horas();
    }, 12 * 60 * 60 * 1000);

    // this.$isLocationSelected = this.navHeaderService.getIsLocationSelected();
    // this.subscription_isLocationSelected = this.$isLocationSelected.subscribe((element) => {
    //   this.isLocationSelected = element;
    // });

    // this.$isRoutesSelected = this.navHeaderService.getIsRoutesSelected();
    // this.subscription_isRoutesSelected = this.$isRoutesSelected.subscribe((element) => {
    //   this.isRoutesSelected = element;
    // });

    // this.$isGeofencesSelected = this.navHeaderService.getIsGeofencesSelected();
    // this.subscription_isGeofencesSelected = this.$isGeofencesSelected.subscribe((element) => {
    //   this.isGeofencesSelected = element;
    // });

    this.$pushedClassSelected = this.navHeaderService.getPushedClass();
    this.subscription_pushedClassSelected = this.$pushedClassSelected.subscribe((element) => {
      this.pushedClassSelected = element;
    });

    this.$clientes = this.callbackService.getClientes();
    this.subscription_clientes = this.$clientes.subscribe((element) => {
      this.clientes = element;

      //dummy logos
      this.clientes.forEach ( cliente => {
        cliente.logo = `logo Mapix.svg`;
      })
    });

    this.$clienteDisplay = this.callbackService.getClienteDisplay();
    this.subscription_clienteDisplay = this.$clienteDisplay.subscribe((element) => {
      this.clienteDisplay = element;
      this.selectedClient = this.clientes.find(client => client.customerName === element);
    });

    this.$views = this.callbackService.getViews();
    this.subscription_views = this.$views.subscribe((element) => {
      this.views = element;
      // this.updateFilteredViews();
    });

    this.sessionService.loadedMapComponents.subscribe(() => {
      // this.updateFilteredViews();
      // changeDetectorRef.detectChanges();
    });
  }

  async ngOnInit() {
    this.checkingURL();
    this.tutorialService.setupTours();
    await this.CheckCallback();
    this.navHeaderService.CheckMapPaneles();
    //abre la conexion con el nuevo cliente si no existe una conexion activa (en caso de cambio de cliente)
    if (this.signalRService.signalConnection == null) {
      this.UnsubscribeSignalUser(this.signalUser);

       this.startHubConnection();
    }
    this.notificationService.getActiveNotificationsCount();
    this.notificationService.getNotifications(1);

    // setTimeout(() => {
    //   this.alarmService.checkAlarms(this.mobileQuery.matches);
    // }, 2000);
  }


  ngOnDestroy() {
    if (this.subscription_SetClients)
      this.subscription_SetClients.unsubscribe();
    if (this.subscription_GetAlarms)
      this.subscription_GetAlarms.unsubscribe();
  }

  onClickMenuButton(id) {
    //los if son para paneles del mapa, el else para las demas vistas
    if(!environment.production) console.log(id);
    const mapUrl = this.callbackService.getMapUrl(); 
    if (id == "locationsMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate([mapUrl,],{queryParams:{ selectedPanel: 'locationsMap'}});
      this.navHeaderService.setIsLocationSelected(true);
    } else if (id == "routingMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate([mapUrl,],{queryParams:{ selectedPanel: 'routingMap'}});
      this.navHeaderService.setIsRoutesSelected(true);
    } else if (id == "geofencesMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate([mapUrl,],{queryParams:{ selectedPanel: 'geofencesMap'}});
      this.navHeaderService.setIsGeofencesSelected(true);
    } else if (id == "potentialZonesMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate([mapUrl],{queryParams:{ selectedPanel: 'potentialZonesMap'}});
      this.navHeaderService.setIsPotentialZonesSelected(true);
    } else if (id == "prospectsMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate([mapUrl],{queryParams:{ selectedPanel: 'prospectsMap'}});
      this.navHeaderService.setIsProspectsSelected(true);
    } else if (id == "frecuencyZonesMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate([mapUrl],{queryParams:{ selectedPanel: 'frecuencyZonesMap'}});
      this.navHeaderService.setIsFrecuencyZonesSelected(true);
    } else if (id == "territoriesMap") {
      this.navHeaderService.setPushedClass();
      this.router.navigate([mapUrl],{queryParams:{ selectedPanel: 'territoriesMap'}});
      this.navHeaderService.setIsTerritoriesSelected(true);
    } else {
      this.router.navigateByUrl("/" + id);
    }
    this.isEnlargedSideBar = false;

    if(!this.mobileQuery.matches){
      this.sidenav.close();
    }
  }

  private async CheckCallback() {
    //checa el callback y muestra la carga
    this.isLoading = true;
    await this.callbackService.isNeededCallback();
    this.isLoading = false;

    //realiza las views y dependiendo del número, redirige a la página de error
    this.views = this.encriptionService.DecryptViews();
    if (this.views.length == 0) {
      this.routerService.navigate(["/error"]);
    }else{
      // this.routerService.navigate(["/unifiedMap"]);
    }
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
    if(!environment.production) console.log("session", this.isExternalMap);
  }

  async Logout() {
    this.closeHubConnection();
    this.imageCacheService.clearImageCache();
    this.dialog.closeAll();
    this.layerCatalogService.isExternalLayersVisible = false;
    this.layerCatalogService.isExternalLayersButtonDisabled = true;
    this.layerCatalogService.isInternalLayersVisible = false;
    this.layerCatalogService.isMapLayersVisible = false;
    this.infoBoxMapService.infoBoxClick.next(null);
    this.maphelperService.mainSourceSubject.next(null);
    let resp = this.authService.Logout();
  }

  //Metodo para actualizar al cliente default despues de 20 horas
  async eventoDespuesDe12Horas() {
    if(!environment.production) console.log("onWindowSleep");
    this.closeHubConnection();
    let resp = this.authService.Logout();
  }

  async onChangeClient(event: any) {

    this.isLoading = true;
    var cliente = event.value;
    
    try {
      const updateClientIdPromise = firstValueFrom( this.authService.UpdateClientId(cliente).pipe(take(1)));
      // llama al callback con la promesa para hacer todas al mismo timpo, dentro se encargará de verificar si sí se actualiza
      const updateClientIdResult = await updateClientIdPromise;

      if (updateClientIdResult && updateClientIdResult.isSuccess){
        this.localStorageService.setClienteSeleccionado(this.encriptionService.EncryptData(cliente.customerName ));
        this.localStorageService.setClienteSeleccionadoId(this.encriptionService.EncryptData(cliente.idCustomer));
        this.localStorageService.setClienteSeleccionadoTypeId(this.encriptionService.EncryptData(cliente.idCustomerType));
        await this.callbackService.dataCallbackOneCall(false);
        this.callbackService.assignNavbarValues();
      }
    } catch (error) {
      this.clienteDisplay = this.encriptionService.DecryptData(this.localStorageService.getClienteSeleccionado());
      this.isLoading = false;
    } finally {
      this.clienteDisplay = this.encriptionService.DecryptData(this.localStorageService.getClienteSeleccionado());
      this.isLoading = false;
      const mapUrl = this.callbackService.getMapUrl();
      this.router.navigate([mapUrl]);
      setTimeout(() => {
        location.reload();
      }, 100);
    }
  }

  EnlargeOrCloseSideBar(){
    if(!this.mobileQuery.matches){
      this.sidenav.toggle();
    }else{
      this.isEnlargedSideBar = !this.isEnlargedSideBar;
    }
  }

  EnlargeSideBar(){
    if(!this.mobileQuery.matches){
      this.sidenav.toggle();
    }else{
      this.isEnlargedSideBar = true;
    }
  }
  
  CloseSideBar(event?: MouseEvent){
    this.closeTimeout = setTimeout(() => {
      const relatedTarget = event?.relatedTarget as Element | null;
      const activeTooltips = relatedTarget?.className?.toString().includes('mdc-tooltip') ?? false;
      
      if (activeTooltips) {
        return;
      }
      if(!this.mobileQuery.matches){
        this.sidenav.toggle();
      }else{
        this.isEnlargedSideBar = false;
      }
    }, 300);
  }

  StopCloseTimeout() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  toggleOptions(): void {
    this.areOptionsExpanded = !this.areOptionsExpanded;
  }

// notificaciones ------------------------------

  toggleNotifications(): void {
    this.notificationService.toggleNotifications();
  }

  // fin de notificaciones ------------------------------

  ToggleAlarms() {
    this.alarmService.ToggleAlarms(this.mobileQuery.matches);
  }

  ResetTutorials() {
    var resp = this.notifyService.confirmMessage("Reactivar tutoriales","Se activara nuevamente el tutorial inicial, ¿Desea continuar?");
    resp.then((result) =>{
      if (result.isConfirmed) {
        this.localStorageService.setShownTutorials(JSON.stringify([]));
        document.location.reload();
      }
    });
  }

  async startHubConnection(){
    this.signalRService.startConnection();
    
    try {
      await this.signalRService.waitForConnectionId(10000);
      this.SubscribeSignalUser(this.signalUser);
    } catch (error) {
      console.error('Error esperando ConnectionId:', error);
      // Intenta suscribir de todos modos
      this.SubscribeSignalUser(this.signalUser);
    }
  }

  closeHubConnection(){
    this.UnsubscribeSignalUser(this.signalUser);
    this.signalRService.endConnection();
  }


  async SubscribeSignalUser(SignalUser: SignalUser) {
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    this.signalUserService.SubscribeGeneralSignalUserService(SignalUser);
    this.signalRService.ActivateListenerNewNotification();
  }

  UnsubscribeSignalUser(SignalUser: SignalUser) {
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    
    this.signalUserService.UnsubscribeSignalUserService();
    this.signalRService.ConnectionId = null;
  }

  updateFilteredViews() {
    const permissionList = this.encriptionService.DecryptList();
    if (!permissionList) {
      this.filteredViews = [];
      return;
    }

    // Obtener y parsear mapLoadedViews una sola vez (más eficiente)
    const mapLoadedViewsEnc = this.localStorageService.getMapLoadedViews();
    var mapLoadedViewsArr: any[] = [];
    if (mapLoadedViewsEnc) {
      const decrypted = this.encriptionService.DecryptData(mapLoadedViewsEnc);
      if (decrypted) {
        try {
          const parsed = JSON.parse(decrypted);
          if (Array.isArray(parsed)) {
            mapLoadedViewsArr = parsed;
          }
        } catch (e) {
          mapLoadedViewsArr = [];
        }
      }
    }

    const modules = MAP_MODULE_NAMES as any;
    const moduleValues = Object.values(modules);

    this.filteredViews = (this.views).filter(view => {
      const hasPermission = permissionList.includes(view.name);
      if (!hasPermission) 
        return false;

      // Verificar si el view es un módulo del mapa que requiere estar cargado
      const checkLoaded = moduleValues.includes(view.name);
      // console.log("views",  view.name, mapLoadedViewsArr, mapLoadedViewsArr.includes(view.name), checkLoaded);
      
      if (checkLoaded) {
        return mapLoadedViewsArr.includes(view.name);
      }
      return true;
    });
  }
}
